export const DISPLAY_ITEMS_PER_PAGE = 10
